export const fields = [
    {
        key: "LGA",
        label: "LGA",
        format: "title case",
        popupView: true,
        listView: true,
    },
    {
        key: "Project",
        label: "Project name",
        listView: true,
        isKey: false,
        listViewWidth: "400px",
        popupView: false,
    },
    {
        key: "Reserve Name",
        label: "Reserve name",
        listViewLabel: "Reserve",
        popupView: false,
        listView: true,
        isKey: false,
    },
    {
        key: "fundName",
        label: "Funding source",
        listView: true,
        popupView: false,
        isKey: false,
        listViewWidth: "180px",
    },
    {
        key: "clm",
        label: "Crown land manager",
        listView: true,
        popupView: true,
    },
    {
        key: "grantApprovedAmount",
        label: "Funding provided",
        listViewLabel: "Funding",
        listView: true,
        popupView: true,
        format: "dollars",
        listViewWidth: "110px",
    },
    {
        key: "Project Year",
        label: "Project year",
        popupView: true,
        listView: false,
    },
    {
        key: "projectStatus",
        label: "Project status",
        listViewLabel: "Status",
        listViewWidth: "100px",
        popupView: false,
        listView: false,
    },
    {
        key: "subFundingSource",
        label: "Funding round",
        popupView: true,
        listView: false,
    },
    {
        key: "reserveNo",
        label: "Reserve number",
        popupView: false,
        listView: false,
    },
    {
        key: "applicationNo",
        label: "Application number",
        listViewLabel: "Application number",
        popupView: true,
        listView: true,
        isKey: true,
    },
    // {
    //     key: "Latitude",
    //     label: "Latitude",
    //     popupView: true,
    //     listView: false,
    //     visuallyHidden: true,
    // },
    // {
    //     key: "Longitude",
    //     label: "Longitude",
    //     popupView: true,
    //     listView: false,
    //     visuallyHidden: true,
    // },
];

export const fieldsMap = fields.reduce((acc, curr) => {
    return {
        ...acc,
        [curr.key]: curr,
    };
}, {});



// WEBPACK FOOTER //
// ./src/modules/fields.js